import { useCallback } from "react";
import { useAppQuoteContext } from "../../../../../../context/AppQuoteContext";

const useDraggableExpandableHelper = (
	tabItem,
	setTabName,
	setChange,
	tabName,
	updateOpenTab,
	setDuplicatedTabId
) => {
	const {quote} = useAppQuoteContext();
	const getOption = (option) => {
		let currentTab = null;
		quote.Tabs.forEach((tab) => {
			if (tab.IdQuoteTabs === tabItem?.IdQuoteTabs) {
				currentTab = tab;
			}
		});
		if (currentTab && tabItem?.IdQuoteTabs) {
			return currentTab[option];
		}
		return false;
	};

	const getTabName = useCallback((tabItem) =>
	{
		if (tabItem?.IdQuoteTabs)
		{
			return tabItem?.TabName || '';
		}
		else
		{
			return "Add New Tab";
		}
	}, [ tabItem?.IdQuoteTabs, tabItem?.TabName ]);

	const getTabNumber = useCallback((tabItem) =>
	{
		return tabItem?.TabNumber;
	}, [ tabItem ]);

	const saveTabName = () => {
		const afterUpdate = function (msg) {
			if (msg.error) {
				Dialog.open({
					title: "ERROR",
					message: msg.error,
					links: [
						{
							title: "OK",
							callback: function callback() {
								Dialog.close();
							}
						}
					]
				});
			} else {
				quote.Tabs.forEach((tab) => {
					if (tab.IdQuoteTabs === tabItem?.IdQuoteTabs) {
						tab.TabName = tabName;
					}
				});
				setTabName(tabName);
				const termOptionsTab = "Term Options";
				if (tabName === termOptionsTab || tabItem?.TabName === termOptionsTab) {
					setChange();
				}
				quosal.sell.quote.updateFromApiResponse(msg);
			}
		};

		const updateApi = quosal.api.data.update(
			{
				fields: {
					TabName: tabName
				},
				queries: [
					{
						table: "QuoteTabs",
						where: [
							{
								field: "IdQuoteTabs",
								operator: "Equals",
								value: tabItem?.IdQuoteTabs
							}
						]
					}
				]
			},
			quote.IdQuoteMain
		);
		updateApi.finished = function (msg) {
			afterUpdate(msg);
		};
		updateApi.call();
		const foundTab = quote.Tabs.find((tab) => tab.IdQuoteTabs === tabItem?.IdQuoteTabs);
		if (foundTab) {
			foundTab.TabName = tabName;
			quosal.sell.quote.update(quote);
		}
	};

	const createColorGroups = () => {
		quosal.util.color.pallette.default.reset();
		const optionGroupColors = {};
		const tabGroupColors = {};
		const optionGroups = [];
		const tabGroups = [];
		const currentQuoteTabs = quote.Tabs;

		for (let tab = 0; tab < currentQuoteTabs.length; tab++) {
			const quoteTab = currentQuoteTabs[tab];

			if (
				!quosal.util.nullOrEmpty(quoteTab.TabGroup) &&
				tabGroups.indexOf(quoteTab.TabGroup) < 0
			) {
				tabGroups.push(quoteTab.TabGroup);
			}

			if (
				!quosal.util.nullOrEmpty(quoteTab.OrderPorterGroup) &&
				optionGroups.indexOf(quoteTab.OrderPorterGroup) < 0
			) {
				optionGroups.push(quoteTab.OrderPorterGroup);
			}
		}

		optionGroups.sort();
		tabGroups.sort();

		for (let i = 0; i < tabGroups.length; i++) {
			tabGroupColors[tabGroups[i]] = quosal.util.color.pallette.default.nextColor();
		}

		for (let i = 0; i < optionGroups.length; i++) {
			optionGroupColors[optionGroups[i]] = quosal.util.color.pallette.default.nextColor();
		}

		const groupColors = {
			tabGroupColors,
			optionGroupColors
		};

		return groupColors;
	};

	const getOptionGroupLabelColor = () => {
		let optionGroupLabelColor = null;
		const { optionGroupColors } = createColorGroups();
		quote.Tabs.forEach((tab) => {
			if (tab.IdQuoteTabs === tabItem?.IdQuoteTabs) {
				optionGroupLabelColor = optionGroupColors[tab.OrderPorterGroup];
			}
		});

		return optionGroupLabelColor;
	};

	const getTabGroupLabelColor = () => {
		let tabGroupLabelColor = null;
		const { tabGroupColors } = createColorGroups();
		quote.Tabs.forEach((tab) => {
			if (tab.IdQuoteTabs === tabItem?.IdQuoteTabs) {
				tabGroupLabelColor = tabGroupColors[tab.TabGroup];
			}
		});

		return tabGroupLabelColor;
	};

	const getOptionGroupLabelTitle = () => {
		let labelTitle = null;
		quote.Tabs.forEach((tab) => {
			if (tab.IdQuoteTabs === tabItem?.IdQuoteTabs) {
				labelTitle = tab.OrderPorterGroup;
			}
		});

		return labelTitle;
	};

	const getTabGroupLabelTitle = () => {
		let labelTitle = null;
		quote.Tabs.forEach((tab) => {
			if (tab.IdQuoteTabs === tabItem?.IdQuoteTabs) {
				labelTitle =
					tab.IsGroupQuantityMaster && tab.TabGroup
						? `${tab.TabGroup}(Qty master)`
						: tab.TabGroup;
			}
		});

		return labelTitle;
	};

	const handleDuplicateTab = (isRadioOption, sourceTabId) => {
		const tabId = sourceTabId ?? tabItem?.IdQuoteTabs;
		const currentTab = quote.Tabs.find((tab) => tab.IdQuoteTabs === tabId);
		if (!currentTab) {
			return;
		}

		const duplicateApi = quosal.api.quote.duplicateTab(
			currentTab.IdQuoteMain,
			currentTab.IdQuoteTabs,
			isRadioOption
		);
		duplicateApi.finished = function (msg) {
			quosal.sell.quote.updateFromApiResponse(msg);
			const newIdQuoteTabs = msg.partialResponse?.newTab?.IdQuoteTabs;
			if (!newIdQuoteTabs) {
				return;
			}
			setDuplicatedTabId(newIdQuoteTabs);
			updateOpenTab(newIdQuoteTabs);
		};
		duplicateApi.call();
	};

	return {
		getOption,
		getTabNumber,
		getTabName,
		saveTabName,
		getOptionGroupLabelColor,
		getTabGroupLabelColor,
		getOptionGroupLabelTitle,
		getTabGroupLabelTitle,
		handleDuplicateTab
	};
};

export default useDraggableExpandableHelper;
